module.exports = __webpack_public_path__ + "media/educators/pta-a7a08577.png";